import React from 'react';
import { Area, AreaChart, Bar, CartesianGrid, ComposedChart, Legend, Line, RadialBar, RadialBarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useTheme } from 'styled-components';
import { goalData } from '../../data';
import { ProfessionalGoalCard, ProfessionalGoalSection } from '../styled/ProfessionalGoal.styled';

const ProfessionalGoal = () => {
    const theme = useTheme();
    
    return (
        <ProfessionalGoalSection>
            <h4>Professional Goal</h4>
            <ProfessionalGoalCard>
                <ResponsiveContainer>
                    <AreaChart
                        data={goalData}
                        margin={{
                            top: 0,
                            right: 25,
                            left: 25,
                            bottom: 0,
                        }}
                    >
                        {/* <CartesianGrid strokeDasharray="3 3" /> */}
                        <XAxis dataKey="name" stroke={theme.color.first}  />
                        {/* <YAxis domain={[0, 100]} /> */}
                        <Tooltip contentStyle={{backgroundColor:theme.color.second}} labelStyle={{ color:theme.color.fourth }} />
                        <Area type="monotone" dataKey="Percent" stroke={theme.color.first} fill={theme.color.second} />
                    </AreaChart>
                </ResponsiveContainer>
            </ProfessionalGoalCard>
        </ProfessionalGoalSection>
    );
};

export default ProfessionalGoal;